import {
  GET_PROVIDER_SALES_DISTRIBUTION,
  GET_PROVIDER_SALES_DISTRIBUTION_ERROR,
  GET_PROVIDER_SALES_DISTRIBUTION_SUCCESS
} from './ProviderSalesDistributionSection.actions'

const providerSalesDistributionSectionState = {
  csv: [],
  data: [],
  error: null,
  lengthData: 1,
  loading: false,
  totalAmount: 0,
  totalAmountUSD: 0,
  totalOrders: 0
}

/**
 * The provider sales distribution section's reducer.
 */
const providerSalesDistributionSectionReducer = (state = providerSalesDistributionSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDER_SALES_DISTRIBUTION: {
      return { ...state, data: [], loading: true }
    }
    case GET_PROVIDER_SALES_DISTRIBUTION_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDER_SALES_DISTRIBUTION_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default providerSalesDistributionSectionReducer
